import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const GROUPS = [
  ["vehicle", "Vehículo", [["vin", "VIN"], ["plates", "Placas"], ["brand", "Marca"], ["model", "Modelo"], ["year", "Año"], ["color", "Color"], ["economic_number", "No. económico"]]],
  ["device", "Dispositivo GPS", [["brand", "Marca"], ["model", "Modelo"], ["imei", "IMEI"], ["sim_iccid", "SIM / ICCID"], ["serial", "No. de serie"]]],
];

export const GpsFields = ({ value, onChange, disabled }) => (
  <div className="grid gap-5 md:grid-cols-2" data-testid="gps-fields">
    {GROUPS.map(([k, title, fields]) => (
      <div key={k} className="space-y-2">
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary">{title}</div>
        <div className="grid grid-cols-2 gap-2">
          {fields.map(([f, label]) => (
            <div key={f} className="space-y-1">
              <Label className="text-[11px] text-muted-foreground">{label}</Label>
              <Input className="h-10" disabled={disabled} value={value?.[k]?.[f] || ""} data-testid={`gps-${k}-${f}`}
                onChange={(e) => onChange({ ...value, [k]: { ...(value?.[k] || {}), [f]: e.target.value } })} />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
